import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { TeamDetailFragment } from 'generated/resources/graphql'

import EditModal from 'modules/teams/components/EditModal'

import Leaders from './Leaders'
import Members from './Members'

interface Props {
  team: TeamDetailFragment
  readonly: boolean
  hasDevJobCatalogTree: boolean
  canCreateJob: boolean
}

const Detail = ({ team, readonly, hasDevJobCatalogTree, canCreateJob }: Props) => {
  const [openEditModal, setOpenEditModal] = useState(false)

  return (
    <>
      <Leaders team={team} readonly={readonly} hasDevJobCatalogTree={hasDevJobCatalogTree} />
      <Members
        team={team}
        readonly={readonly}
        hasDevJobCatalogTree={hasDevJobCatalogTree}
        canCreateJob={canCreateJob}
      />
      <Box alignItems="center">
        {openEditModal && <EditModal onClose={() => setOpenEditModal(false)} team={team} />}
      </Box>
    </>
  )
}

export default Detail
